import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { DescribeUserResponse } from "lib/generated/admin-api/models";
import { useAdminApi } from "lib/stotlesAdminApiContext";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "../utils";

type QueryKey = [string, string];

export function useDescribeUser(
  guid: string,
  options?: UseQueryOptions<DescribeUserResponse, unknown, DescribeUserResponse, QueryKey>,
) {
  const { api } = useAdminApi();
  return useQuery(
    ["userDetails", guid],
    async () => {
      const user = await api.describeUser({ describeUserRequest: { guid } });
      return user;
    },
    {
      ...REACT_QUERY_OPTIONS_NEVER_REFETCH,
      ...options,
    },
  );
}
